<template>
  <div>
      <h1>{{country.name}}</h1>
      <div class="more-info">
          <div class="more-info--main">
              <p><strong>Native Name: </strong>{{country.nativeName}}</p>
              <p><strong>Population: </strong>{{country.population.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</p>
              <p><strong>Region: </strong>{{country.region}}</p>
              <p><strong>Sub Region: </strong>{{country.subregion}}</p>
              <p><strong>Capital: </strong>{{country.capital}}</p>
          </div>
          <div class="more-info--sub">
                <p>
                    <strong>Top Level Domain: </strong>
                    <span v-for="(domain, index) in country.topLevelDomain"
                    :key="index + 1" 
                    > {{domain}}<i v-if="index !== country.topLevelDomain.length - 1">, </i></span>
                </p>
                <p>
                    <strong>Currencies: </strong>
                    <span v-for="(currency, index) in country.currencies" 
                    :key="index + 1" 
                    > {{currency.name}}<i v-if="index !== country.currencies.length - 1">, </i></span>
                </p>
                <p>
                    <strong>Language: </strong>
                    <span v-for="(language, index) in country.languages" 
                    :key="index + 1" 
                    > {{language.name}}<i v-if="index !== country.languages.length - 1">, </i></span>
                </p>
          </div>
      </div>
      <div class="border-countries-container" v-if="country.borders.length > 0">
          <p class="label">Border Countries: </p>
          <AppBorderCountries v-for="(alphaCode, index) in country.borders" :key="index + 1" 
          :countryCode="alphaCode"/>
      </div>
  </div>
</template>

<script>
import AppBorderCountries from './AppBorderCountries.vue'
export default {
    props: ['country'],
    components: {AppBorderCountries},
    data() {
        return{
            
        }
    }
}
</script>

<style lang="scss" scoped>
.label {
    font-weight: 600;
}
h1 {
    font-size: 1.5rem;
    margin-bottom: .75em;
    @media (min-width: 58.75em) {
        
    }
}
.more-info {
    display: flex;
    flex-flow: row wrap;
    gap: 1.5rem;
    @media (min-width: 58.75em) {
       
    }
    //  @media (min-width: 58.75em) {
    //     display: flex;
    //     justify-content: space-between;
    //     align-items: flex-start;
    //     max-width: 28rem;
    // }
    > .more-info--main + * {
        @media (min-width: 58.75em) {
            margin-top: 0;
        }
    }
    strong {
        font-weight: 600;
    }
}
.border-countries-container {
    display: flex;
    flex-flow: row wrap;
    gap: 1rem;
    align-items: baseline;
    margin: 3em 0;
    
}
</style>